import React from 'react'
import { SettingsMenuItem } from 'src/editor/shared/components/settings-menu-buttons/settings-menu-item'
import { twMerge } from 'tailwind-merge'

interface FormAddNewSubEntitySettingsItemProps
  extends Omit<React.LiHTMLAttributes<HTMLLIElement>, 'onChange'> {
  skipTranslation?: boolean
  title: string
  icon?: () => React.ReactNode
  controlComponent: () => React.ReactNode
  settingsMenuItemTitleClassName?: string
}

export const FormAddNewSubEntitySettingsItem = ({
  className,
  title,
  skipTranslation,
  icon,
  controlComponent,
  settingsMenuItemTitleClassName,
  ...props
}: FormAddNewSubEntitySettingsItemProps) => {
  return (
    <li
      className={twMerge(
        'flex min-h-9 w-full items-center justify-between rounded-md px-0.5',
        className,
      )}
      {...props}
    >
      <SettingsMenuItem
        title={title}
        skipTranslation={skipTranslation}
        icon={icon}
        titleClassName={settingsMenuItemTitleClassName}
      />
      {controlComponent()}
    </li>
  )
}
